export default __webpack_public_path__ + "static/media/ies_PagoIluminare.7f1956aa.png";